import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

import Button from 'components/common/Button';

const styles = () => ({
  toolbar: {
    marginBottom: 25,
  },
});

const DataPortabilityNavigation = ({ dataPortability, classes }) => (
  <Toolbar className={classes.toolbar} disableGutters>
    {dataPortability.filter(item => ['diagnosis', 'hcpc', 'payers'].indexOf(item.Route) === -1).map(({ ID, Title, Route }) => (
      <Button
        nav
        key={ID}
        href={`/settings/data-portability/${Route}`}
        exact
      >
        {Title}
      </Button>
    ))}
  </Toolbar>
);

DataPortabilityNavigation.propTypes = {
  dataPortability: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    Route: PropTypes.string.isRequired,
    Title: PropTypes.string.isRequired,
  })).isRequired,
  classes: PropTypes.shape({
    toolbar: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(DataPortabilityNavigation);



// WEBPACK FOOTER //
// ./src/components/settings/DataPortabilityNavigation/DataPortabilityNavigation.js